import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-inicio-sesion',
  templateUrl: './acceso-usuario.component.html',
  styleUrls: ['./acceso-usuario.component.scss']
})
export class AccesoUsuarioComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle('Agendamiento de proveedores para la minería');
  }

  ngOnInit(): void {
  }

}
